import React from "react";

export default function Loader(): React.ReactElement {
  return (
    <div className="relative flex items-center justify-center">
      <div className="flex items-center justify-center">
        <div className="z-10 flex space-x-2 text-current">
          <div
            className="h-2.5 w-2.5 rounded-full bg-current opacity-30"
            style={{
              animation: "loading-dots 1s infinite ease-in-out alternate",
              animationDelay: "0s",
            }}
          ></div>
          <div
            className="h-2.5 w-2.5 rounded-full bg-current opacity-30"
            style={{
              animation: "loading-dots 1s infinite ease-in-out alternate",
              animationDelay: "0.5s",
            }}
          ></div>
          <div
            className="h-2.5 w-2.5 rounded-full bg-current opacity-30"
            style={{
              animation: "loading-dots 1s infinite ease-in-out alternate",
              animationDelay: "1s",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
}
